import React from "react";
import { Box, Button, Paper, Stack, Typography, Divider } from "@mui/material";

export default function Kpi({
  title,
  icon,
  value,
  unit,
  target,
  targetUnit = "",
  color = "#3B82F6",
  actionLabel = "Ekle",
  onAction,
  size = "short",
  showTarget = true, // ✅ yeni prop
  disabled = false,
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        borderRadius: 4,
        border: `3px solid ${color}40`,
        bgcolor: `${color}08`,
        width: "100%",
        maxWidth: 500,
        minWidth: 300,
        minHeight: 200,
        display: "flex",
        flexDirection: "column",
        boxShadow: "0 10px 30px rgba(17,24,39,0.06)",
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1.5 }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <Box sx={{ color, display: "flex", fontSize: 20 }}>{icon}</Box>
          <Typography sx={{ fontWeight: 500, fontSize: 13, color: "#6B7280" }}>
            {title}
          </Typography>
        </Stack>


{ disabled ? null : <Button
          size="small"
          variant="outlined"
          onClick={onAction}
          disabled={disabled}
          sx={{
            height: 26,
            minWidth: 65,
            borderRadius: 2,
            textTransform: "none",
            fontSize: 12,
            fontWeight: 800,
            color: "#374151",
            borderColor: "#E5E7EB",
            bgcolor: "#fff",
            boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
            "&:hover": { bgcolor: "#F9FAFB", borderColor: "#D1D5DB" },
          }}
        >
          + {actionLabel}
        </Button>}
        
      </Stack>

      <Stack direction="row" spacing={0.5} alignItems="baseline">
        <Typography sx={{ fontSize: 34, fontWeight: 900, letterSpacing: -1 }}>
          {value}
        </Typography>
        <Typography sx={{ fontSize: 14, fontWeight: 600, color: "#9CA3AF" }}>
          {unit}
        </Typography>
      </Stack>

      {/* ✅ showTarget true ise göster */}
      {showTarget && (
        <Box sx={{ mt: 2 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography sx={{ fontSize: 12, color: "#9CA3AF", fontWeight: 500 }}>
              Olması gereken değer:
            </Typography>
            <Typography sx={{ fontSize: 12, fontWeight: 800, color }}>
              {target} {targetUnit}
            </Typography>
          </Stack>
        </Box>
      )}

      <Divider sx={{ mt: 2, mb: 1.6, borderColor: "rgba(0,0,0,0.08)" }} />
    </Paper>
  );
}
